<template>
	<div class="dealers-projects">
		<action-sidebar
			title="Template"
			:value="true"
			:width="644"
			@close-modal="closeModal"
		>
			<v-tabs 
				v-model="tabsModel"
				right
				slider-color="cyan">
				<v-tab v-for="(item, index) in tabs" :key="index">
					{{item.name}}
				</v-tab>
				<v-tabs-items>
					<v-tab-item>
						<app-table
						selectable
						class="mt-3 is-not-selectable px-4"
						name="template"
						:last-page="lastPage"
						:columns="columns"
						:rows="template"
						:check-all="checkAll"
						:selected-value="selectedValue"
						:current-page="currentPage"
						@on-selected-all="allIsSelected"
						@on-search-event="onSearch"
						@row-is-selected="rowIsSelected"
						@on-page="changePage"			
						>
							<template slot="rows" slot-scope="props">
								<td class="is-not-selectable"
								v-show="showRow(columns, 1)">
									{{ props.row.name }}
								</td>
								<td v-show="showRow(columns, 2)">
									{{ props.row.description }}
								</td>
							</template>
						</app-table>
					</v-tab-item>
					<v-tab-item>
						<app-table
						selectable
						class="mt-3 is-not-selectable px-4"
						:selected-value="selectedValueAssigned"
						:check-all="checkAllDeallocate"
						:columns="columns"
						:rows="templateAssigned"
						:current-page="currentPageDeallocate"
						:last-page="lastPageDeallocated"
						@on-selected-all="allIsSelectedDeallocate"
						@on-search-event="onSearchTemplateDeallocate"
						@row-is-selected="rowIsSelectedDeallocate"
						@on-page="changePageDeallocate"
						>
							<template slot="rows" slot-scope="props">
								<td v-show="showRow(columns, 1)">
									{{ props.row.name }}
								</td>
								<td v-show="showRow(columns, 2)">
									{{ props.row.description }}
								</td>
							</template>
						</app-table>
					</v-tab-item>
				</v-tabs-items>
			</v-tabs>
			<section class="modal-filter-footer pt-3 pb-3 content-buttons">
				<v-btn
				class="btn-action caption mr-1"
				color="pink"
				@click="closeModal">
					Cancelar
					<v-icon class="ml-2" size="18">close</v-icon>
				</v-btn>
				<v-btn 
				class="btn-action caption ml-1"
				color="success"
				@click="assignedTemplate"
				:disabled="disabledAssigned(1)"
				>
					Asignar
				</v-btn>
				<v-btn
				class="btn-action caption ml-2" 
				color="success"
				@click="deleteTemplate"
				:disabled="disabledDeallocated(0)">
					Desasignar
				</v-btn>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import tableAssign from '@/components/configuration/table-assign';

function disabledAssigned(value) {
	return	this.tabsModel === value || this.dataSelected.length < 1;
}

function disabledDeallocated(value) {
	return this.tabsModel === value || this.dataSelectedDeallocate.length < 1;
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.listTemplate();
}

function changePageDeallocate(page) {
	this.params.page = page;
	this.currentPageDeallocate = page;
	this.listTemplateDeallocated();
}

function closeModal() {
	this.goTo('page-config-dealers');
}

async function assignedTemplate() {
	const templatesIds = this.dataSelected.map(action => action.id);
	try {
		await this.$http.post(`distributaries/${this.id}/templates`, { templatesIds });
		this.showNotification('Los templates fueron asignados correctamente.');
		this.closeModal();
		this.listTemplate();
	} catch (error) {
		this.showError();
	}
}

async function deleteTemplate() {
	const ids = this.dataSelectedDeallocate.map(item => item.id);
	const body = {
		templatesIds: ids,
	};
	try {
		await this.$http.delete(`distributaries/${this.id}/templates`, { data: body });
		this.showNotification('Template eliminado correctamente');
		this.closeModal();
		this.listTemplateDeallocated();
	} catch (error) {
		this.showError();
	}
}

function rowIsSelectedDeallocate(row) {
	this.templateAssigned = this.selectIsRow(this.templateAssigned, this.selectedValueAssigned, row);
	this.dataSelectedDeallocate = this.templateAssigned.filter(r => r.flag);
	this.checkAllDeallocate = this.every(this.templateAssigned, this.selectedValueAssigned);
}

function rowIsSelected(row) {
	this.template = this.selectIsRow(this.template, this.selectedValue, row);
	this.dataSelected = this.template.filter(r => r.flagSelected);
	this.checkAll = this.every(this.template, this.selectedValue);
}

function created() {
	this.listTemplate();
	this.listTemplateDeallocated();
}

function onSearchTemplateDeallocate(value) {
	this.params.search = value ? value.trim() : null;
	this.listTemplateDeallocated();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.listTemplate();
}

function allIsSelectedDeallocate(checked) {
	this.checkAllDeallocate = checked;
	this.dataSelectedDeallocate = [];
	this.templateAssigned = this.templateAssigned.map((element) => {
		const newRow = { ...element };
		newRow.isSelected = checked;
		if (checked) {
			this.dataSelectedDeallocate.push(element);
		}
		return newRow;
	});
	this.templateAssigned =
		this.selectIsRow(this.templateAssigned, this.selectedValueAssigned, false, checked);
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.dataSelected = [];
	this.template = this.template.map((item) => {
		const newRow = { ...item };
		newRow.isSelected = checked;
		if (checked) {
			this.dataSelected.push(item);
		}
		return newRow;
	});
	this.template = this.selectIsRow(this.template, this.selectedValue, false, checked);
}

async function listTemplate() {
	const params = {
		page: this.params.page,
		search: this.params.search,
		perPage: 20,
		isSelected: 0,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/templates`, { params });
		this.template = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

async function listTemplateDeallocated() {
	const params = {
		page: this.params.page,
		search: this.params.search,
		perPage: 20,
		isSelected: 1,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/templates`, { params });
		this.templateAssigned = response.data.data;
		this.lastPageDeallocated = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function data() {
	return {
		checkAllDeallocate: false,
		checkAll: false,
		currentPage: 1,
		currentPageDeallocate: 1,
		dataSelected: [],
		dataSelectedDeallocate: [],
		lastPage: 0,
		lastPageDeallocated: 0,
		selectedValueAssigned: 'flag',
		selectedValue: 'flagSelected',
		template: [],
		templateAssigned: [],
		columns: [
			{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 2, name: 'Descripción', value: 'description', checked: true, visible: true },
		],
		tabs: [
			{
				id: 1,
				name: 'Asignar',
			},
			{
				id: 2,
				name: 'Asignados',
			},
		],
		tabsModel: null,
	};
}

export default {
	name: 'page-template',
	data,
	created,
	components: {
		actionSidebar,
		tableAssign,
	},
	methods: {
		allIsSelected,
		allIsSelectedDeallocate,
		assignedTemplate,
		changePage,
		changePageDeallocate,
		closeModal,
		deleteTemplate,
		disabledAssigned,
		disabledDeallocated,
		listTemplate,
		listTemplateDeallocated,
		rowIsSelectedDeallocate,
		onSearchTemplateDeallocate,
		onSearch,
		rowIsSelected,
	},
	props: {
		id: {
			type: [Number, String],
		},
	},
};
</script>

<style lang="scss" scoped>
.content-buttons {
	display: flex;
	justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-template.vue